module.exports = __webpack_public_path__ + "img/empty-cart.0bb21187.png";